import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@mui/material';
import { formatTimeToHHmm, getRegNumByVehicleId } from '../../../utils';
import LabelText from './styles/LabelText';
import { WAREHOUSE_CHART_COLOR } from '../../../constants';

function CustomTooltip({ active, payload, label, vehicles }) {
  if (!(active && payload && payload.length)) return null;

  const { y, vehicleId } = payload[0].payload;

  const regNum = getRegNumByVehicleId(vehicleId, vehicles);

  return (
    <Paper elevation={3} sx={{ p: 1 }}>
      <LabelText>{formatTimeToHHmm(label)}</LabelText>
      <LabelText color={WAREHOUSE_CHART_COLOR}>Объем: {`${Number(y.toFixed(2))} (т)`}</LabelText>
      {regNum && <LabelText>{regNum}</LabelText>}
    </Paper>
  );
}

CustomTooltip.propTypes = {
  active: PropTypes.bool.isRequired,
  payload: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  label: PropTypes.string.isRequired,
  vehicles: PropTypes.arrayOf(PropTypes.shape()),
};

CustomTooltip.defaultProps = {
  vehicles: [],
};

export default CustomTooltip;
